import { FormHelperText, TextareaAutosize, TextareaAutosizeProps } from '@mui/material';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import WsColors from '../../WsColors';
import { Label } from '../Label/';

interface IControlledTextArea {
  labelText?: string;
  name: string;
  showMandatorySymbol?: boolean;
}

const ControlledTextArea: FC<TextareaAutosizeProps & IControlledTextArea> = ({
  labelText,
  name,
  showMandatorySymbol = false,
  ...props
}) => {
  const { control } = useFormContext();
  return (
    <>
      {labelText && (
        <Label sx={{ mb: 0.5 }}>
          {labelText}
          {showMandatorySymbol ? ' *' : ''}
        </Label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <TextareaAutosize
              onChange={onChange}
              value={value}
              minRows={3}
              style={{ width: '100%', border: `2px solid ${WsColors.TertiaryShades100}` }}
              {...props}
            />
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </>
  );
};

export default ControlledTextArea;
